import React from 'react';
import { css, useTheme } from '@emotion/react';
import { type ReactFCC } from '@bbkAdminUtils/utility-types';
import { type EmotionTheme } from '@bbkFunnel/pages/theme';

export const LossTitle: ReactFCC = ({ children }) => {
  const theme = useTheme() as EmotionTheme;

  const baseStyles = css({
    marginBottom: '0.5rem',
    fontSize: '1.35rem',
    fontWeight: 'bold',
  });
  const titleThemeStyles = css({
    color: theme.titleFontColor || theme.primaryColor,
    fontWeight: theme.titleFontWeight,
    fontSize: theme.titleFontSize,
    fontFamily: theme.titleFontFamily,
    textTransform: theme.titleTextTransform,
  });

  return (
    <div
      className="bbk-loss-component-title"
      css={[baseStyles, titleThemeStyles]}
    >
      {children}
    </div>
  );
};
